import { combineReducers } from "redux";
import { reducer as jobs } from "./JobScheduling";
import { reducer as resources } from "./ResourceScheduling";

export default combineReducers({
  jobs,
  resources,
});
